import { customFieldCategories } from 'ducks/entities/schema'

export const customFieldCategoriesNormalizationSchema = {
  customFieldCategories: {
    nodes: [customFieldCategories],
  },
}
